import React, { useState } from "react";

import { useFetchProcessedFile, useFetchUploadHistory, useUploadTenants } from "store/backend/apiHooks";
import FileUpload from "components/FileUpload/FileUpload";
import { useSnackbarContext } from "widgets/SnackBar/SnackBar";
import { TENANT_SCRIPT_ID, UPLOAD_HISTORY_COLUMNS } from "constants/constants";
import { ErrorMessage, PrimaryButton, Table } from "widgets";
import Loader from "shared/Icons/Loader/Loader";
import { formatDate } from "utils/logger";

import styles from "./UploadTenants.module.scss"


const handleOnClickDownloadProcessedFile = (uploadId, openSnackbar, fetchProcessedFile) => {
    if (!uploadId) {
        openSnackbar("No file available for download!", "error");
        return;
    }
    fetchProcessedFile(uploadId, {
        onSuccess: (data) => {
            const link = document.createElement("a");
            link.href = data.signedUrl;
            link.download = "processed_file.csv";
            link.click();
            openSnackbar("Processed File downloaded successfully!", "success");
        },
        onError: (err) => {
            openSnackbar(err.message || "Download failed", "error");
        }
    });
};

const getUploadHistoryTableRows = (uploadHistory, fetchProcessedFile, openSnackbar, isFetchProcessedFileLoading) => {
    if (!Array.isArray(uploadHistory)) {
        return [];
    }
    return uploadHistory.filter((historyRow) => historyRow.scriptId === TENANT_SCRIPT_ID).map((historyRow) => ({
        fileName: historyRow.fileName,
        status: historyRow.status,
        uploadedAt: formatDate(historyRow.uploadedAt),
        downloadProcessedFile: (
            <PrimaryButton
                onClick={() => handleOnClickDownloadProcessedFile(historyRow.uploadId, openSnackbar, fetchProcessedFile)}
            >
                {isFetchProcessedFileLoading ? "Loading..." : "Download"}
            </PrimaryButton>
        ),
    }));
};

const UploadTenants = () => {
    const { openSnackbar } = useSnackbarContext();
    const [loggedInUserId] = useState(localStorage.getItem("loggedInUserId"));
    const { mutate: uploadTenants, isPending: isUploadTenantsLoading } = useUploadTenants();
    const { data: uploadHistory, isLoading: isUploadHistoryLoading, error: errorMessage } = useFetchUploadHistory(loggedInUserId);
    const { mutate: fetchProcessedFile, isLoading: isFetchProcessedFileLoading } = useFetchProcessedFile();

    const uploadHistoryTableRows = getUploadHistoryTableRows(uploadHistory?.data, fetchProcessedFile, openSnackbar, isFetchProcessedFileLoading);

    return (
        <div className={styles.mainContainer}>
            <div className={styles.title}>Upload Tenants</div>
            <div className={styles.uploadTenantsFileContainer}>
                <FileUpload
                    uploadLabel="Upload Tenants"
                    onUpload={uploadTenants}
                    isLoading={isUploadTenantsLoading}
                />
                {isUploadHistoryLoading ? <Loader /> :
                    errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : <Table rows={uploadHistoryTableRows} columns={UPLOAD_HISTORY_COLUMNS} />
                }
            </div>
        </div>
    )
}
export default UploadTenants